import React from 'react';
import { motion } from 'framer-motion';
import { Groups, Verified, Handshake } from '@mui/icons-material';

const ServicesWhyChoose: React.FC = () => {
  const reasons = [
    {
      icon: Groups,
      title: 'Expert Team',
      description: 'Our team consists of skilled professionals with years of experience in video production, branding, and digital content creation. We bring together diverse talents to deliver exceptional results that exceed expectations.'
    },
    {
      icon: Verified,
      title: 'Quality Guaranteed',
      description: 'We are committed to delivering excellence in every project. From concept to completion, we maintain the highest standards of quality, ensuring that your content stands out and makes a lasting impact on your audience.'
    },
    {
      icon: Handshake,
      title: 'Client Focused',
      description: 'Your success is our priority. We take the time to understand your unique needs, goals, and vision. Our collaborative approach ensures that we create content that truly represents your brand and resonates with your target audience.'
    }
  ];

  return (
    <section className="py-20 md:py-32 bg-black">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-20"
        >
          <h2 
            className="text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold mb-6"
            style={{ 
              fontFamily: "'Montserrat', sans-serif",
              color: '#EF3F23',
              letterSpacing: '-0.05em'
            }}
          >
            Why Choose Us
          </h2>
          <p 
            className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            We combine expertise, quality, and dedication to deliver media solutions that help your brand connect with audiences and achieve lasting impact.
          </p>
        </motion.div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 max-w-7xl mx-auto">
          {reasons.map((reason, index) => {
            const IconComponent = reason.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: index * 0.15 }}
                className="text-center p-8 rounded-2xl border-2 border-gray-800 hover:border-[#EF3F23] transition-all duration-300 bg-gray-900/50"
              >
                <div className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center border-2 border-[#EF3F23]" style={{ backgroundColor: '#EF3F2315' }}>
                  <IconComponent style={{ color: '#EF3F23', fontSize: '40px' }} />
                </div>
                <h3 
                  className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4"
                  style={{ 
                    fontFamily: "'Montserrat', sans-serif",
                    color: '#EF3F23',
                    letterSpacing: '-0.05em'
                  }}
                >
                  {reason.title}
                </h3>
                <p 
                  className="text-base md:text-lg text-gray-300 leading-relaxed"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  {reason.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesWhyChoose;
